import * as React from 'react';
import { clsx } from 'clsx';
import { useDeviceType } from '../../../responsive';
import * as styles from '../../styles/grid.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Grid = function Grid(_ref) {
  var children = _ref.children;
  var device = useDeviceType();
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['grid'], device === 'desktop' && styles['large']),
    children: children
  });
};
Grid.displayName = 'Grid';